import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-32 relative overflow-hidden border-t border-white/5" data-id="element-69">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-zinc-800/20 via-zinc-950 to-zinc-950 pointer-events-none" data-id="element-70" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-71">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-72">
          Stop fighting your spreadsheets.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-zinc-400 mb-10 max-w-2xl mx-auto" data-id="element-73">
          Join thousands of teams building faster, smarter models and dashboards
          with AI.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-74">
          <button className="px-8 py-4 bg-white text-zinc-950 rounded-md font-medium text-lg hover:bg-zinc-200 transition-colors shadow-lg shadow-white/10" data-id="element-75">
            Get started free
          </button>
        </motion.div>
      </div>
    </section>;
}